import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { SettingsLayout } from "@/pages/SettingsBranding";
import { toast } from "sonner";
import { FileDown } from "lucide-react";

export default function SettingsBadgeTemplates() {
  const [tpls, setTpls] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const { data } = await api.get("/badge-templates"); setTpls(data); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const preview = async (name) => {
    try {
      const res = await api.post("/badge-templates/preview", { name }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      window.open(url, "_blank");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <SettingsLayout>
      <div data-testid="badge-templates-page">
        <p className="text-sm text-navy-500 mb-4">Badge templates determine the layout of printed/PDF visitor badges. System templates can be cloned and edited.</p>
        <div className="grid md:grid-cols-2 gap-4">
          {loading ? <p className="text-navy-500">Loading…</p> : tpls.map((t) => (
            <div key={t.id} className="eb-card p-5" data-testid={`badge-tpl-${t.name}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-semibold">{t.name}</div>
                  <div className="text-xs text-navy-500">{t.description}</div>
                </div>
                {t.is_system && <span className="text-[10px] uppercase font-bold px-2 py-0.5 rounded bg-navy-100 text-navy-600">System</span>}
              </div>
              <button onClick={() => preview(t.name)} className="btn-outline w-full mt-4" data-testid={`badge-preview-${t.name}`}>
                <FileDown className="w-4 h-4" /> Preview PDF
              </button>
            </div>
          ))}
        </div>
      </div>
    </SettingsLayout>
  );
}
